import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "../../service/api";
import { getStore } from "../../service/store/StoreService";

interface UserRegistrationSlice {
  createdStoreID: number;
  storeTypeList: { id: number; name: string }[];
  values: any;
  stores: any;
  loading: boolean;
  error: any;
  FoodAndBeverageID: string;
  already_used_email_phone:boolean;
  inventory_check:boolean;
}

interface StoreTypeResponse {
  data: any[];
}

const initialState: UserRegistrationSlice = {
  createdStoreID: 0,
  storeTypeList: [],
  values: {},
  stores: [],
  loading: false,
  error: null,
  FoodAndBeverageID: "316",
  already_used_email_phone:true,
  inventory_check:false,
};

export const fetchStoreType = createAsyncThunk(
  "storeType/fetchStoreType",
  async () => {
    const response = await ApiClient.get<StoreTypeResponse>(`category`);
    return response.data.data;
  }
);
export const fetchStores = createAsyncThunk(
  "stores/fetchStores",
  async (
    { page = 1, limit = 10 }: { page: number; limit: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await getStore(page, limit);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
// eslint-disable-next-line @typescript-eslint/no-redeclare
const UserRegistrationSlice = createSlice({
  name: "userRegistration",
  initialState,
  reducers: {
    setStoreID: (state, action: PayloadAction<number>) => {
      state.createdStoreID = action.payload;
    },
    setFormikValues: (state, action: PayloadAction<any>) => {
      state.values = { ...state.values, ...action.payload };
    },
    setAlreadyUsedData : (state,action:PayloadAction<boolean>)=> {
      state.already_used_email_phone= action.payload
    },
    setInventoryCheck :(state,action:PayloadAction<boolean>) => {
      state.inventory_check = action.payload
    },
    resetStoreValues: (state) => {
      state.createdStoreID = 0;
      state.storeTypeList = [];
      state.values = {};
    },
    clearFormValues: (state) => {
      state.values = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStoreType.fulfilled, 
        (state, action: any) => {
          state.storeTypeList = action.payload;
          state.FoodAndBeverageID = String(action.payload.find((item: any) => item.name === "F&B")?.id) || "316";
        }
    )
      //Fetch store list
      .addCase(fetchStores.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStores.fulfilled, (state, action) => {
        state.loading = false;
        state.stores = action.payload.data;
      })
      .addCase(fetchStores.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setStoreID, setFormikValues, resetStoreValues, clearFormValues, setAlreadyUsedData, setInventoryCheck } =
  UserRegistrationSlice.actions;

export default UserRegistrationSlice.reducer;
